import { PayloadAction } from '@reduxjs/toolkit';
import { InverterApi } from 'api/InverterApi';
import { plantApi } from 'api/plantApi';
import { inverterInfo, itemParam, ListResponse } from 'models';
import { call, put, takeLatest } from 'redux-saga/effects';
import { inverterActions } from './inverterSlice';

function* fetchInverterListSaga(action: PayloadAction<itemParam>) {
  try {
    const response: ListResponse<inverterInfo> = yield call(
      plantApi.getInvertersByUserId,
      action.payload
    );
    yield put(inverterActions.fetchInvertersSuccess(response));
  } catch (error) {
    yield put(inverterActions.fetchInverterFailed('fetch inverter list failed'));
  }
}
function* fetchInverterInfoSaga(action: PayloadAction<inverterInfo>) {
  try {
    const response: inverterInfo = yield call(InverterApi.fetchInverterInfo, {type: 'inverter_id', id: action.payload.id});
    yield put(inverterActions.fetchInverterInfoSuccess({ ...action.payload, ...response }));
  } catch (error) {
    yield put(inverterActions.fetchInverterFailed('fetch inverter info failed'));
  }
}

export default function* inverterSaga() {
  yield takeLatest(inverterActions.fetchInverterList.type, fetchInverterListSaga);
  yield takeLatest(inverterActions.fetchInverterInfo.type, fetchInverterInfoSaga);
}
